<div *ngIf="alerts">
  <div *ngFor="let alert of alerts" class="{{cssClass(alert)}}" id="ap-alert-{{id}}-{{alert.htmlBaseId}}">
    <span [innerHTML]="alert.message"></span>
    <a class="close"
       id="ap-alert-{{id}}-{{alert.htmlBaseId}}-close"
       (click)="removeAlert(alert)">&times;</a>
  </div>
</div>
